module.exports = __webpack_public_path__ + "static/img/14一种弯管机水平调节装置.49047f49.jpg";